module.exports = __webpack_public_path__ + "img/40_14.27165786.png";